import { Divider, Form, InputNumber, Row, Col } from "antd";
import { ColorPickerFormItem } from "../Image/ImageConf";

export default ({ node }) => {
  return (
    <>
      <Row gutter={8}>
        <Col span={12}>
          <Form.Item name="size" label="Size">
            <InputNumber min={0} max={100} style={{ width: "100%" }} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="X thickness" name="strokeWidth">
            <InputNumber min={1} max={10} style={{ width: "100%" }} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <ColorPickerFormItem
            label="Color"
            name="color"
            color={node.data.color}
          />
        </Col>
        <Col span={12}>
          <ColorPickerFormItem
            label="Background color"
            name="backgroundColor"
            color={node.data.backgroundColor}
          />
        </Col>
        <Col span={12}>
          <ColorPickerFormItem
            label="Border Color"
            name="borderColor"
            color={node.data.borderColor}
          />
        </Col>
      </Row>
      <Divider />
      <Row gutter={8}>
        <Col span={12}>
          <Form.Item name="marginTop" label="Margin top">
            <InputNumber style={{width: "100%"}} min={-60} max={60} step={5} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="marginRight" label="Margin right">
            <InputNumber style={{width: "100%"}} min={-60} max={60} step={5} />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};
